import React, { useState } from 'react'
import { useRecoilValue } from 'recoil'
import { Text, IconButton, TextInput } from 'components'
import { userInfoState } from 'store/atom/user-state-atom'
// css
import 'assets/style/components/comment-list-re.scss'

function Element({
  reply = { cmntCn: '', regrId: '', reply: '' },
  dispAuthor = true,
  onModify = () => {},
  onDelete = () => {},
}) {
  const userInfo = useRecoilValue(userInfoState)

  const [isShow, setIsShow] = useState(false)
  const [isModify, setIsModify] = useState(false)
  const [modifyCn, setModifyCn] = useState('')

  const toggleModify = () => {
    setIsShow(false)
    setIsModify((prev) => {
      if (!prev) {
        setModifyCn(reply.cmntCn)
      }
      return !prev
    })
  }

  const modifyReply = () => {
    onModify(
      {
        ntcAtclId: reply.ntcAtclId,
        cmntId: reply.cmntId,
        hgrnkCmntId: reply.hgrnkCmntId,
        cmntCn: modifyCn,
        useYn: 'Y',
      },
      () => {
        setIsModify(false)
      },
    )
  }

  const deleteReply = () => {
    onDelete(reply, () => {
      setIsModify(false)
    })
  }
  return (
    <ul className="reply-list mt16">
      <li>
        <div className="flex-between">
          <div className="comment-list-info">
            {(dispAuthor || reply?.magrRegYn === 'Y') && (
              <Text className="f-12 c-6">
                {reply.regrNm}[{reply.deptNm}]
              </Text>
            )}
            <Text className="f-12 date">{reply.regDttm}</Text>
          </div>
          {userInfo.userId === reply.regrId && reply.useYn === 'Y' && (
            <div className="more-area">
              <IconButton
                type="more"
                size="20"
                bg=""
                onClick={() => {
                  setIsModify(false)
                  setIsShow((prev) => {
                    return !prev
                  })
                }}
              />
              {isShow ? (
                <>
                  <div className="popup-dim" style={{ opacity: '0' }} onClick={() => setIsShow(false)}></div>
                  <div className="floating-menu" style={{ zIndex: '12' }}>
                    <span onClick={deleteReply}>삭제</span>
                    <span onClick={toggleModify}>수정</span>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
        {isModify ? (
          <div className="reply-form flex">
            <div className={'input-text-wrap'}>
              <input
                value={modifyCn}
                onChange={(e) => {
                  setModifyCn(e.target.value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    modifyReply()
                  }
                }}
              />
            </div>
            <IconButton type="write" size="20" onClick={modifyReply} />
          </div>
        ) : (
          <>
            <Text
              className="mt4 sub-title"
              onClick={() => {
                setIsShow(false)
              }}
            >
              {reply.cmntCn}
            </Text>
          </>
        )}
      </li>
    </ul>
  )
}

export default Element
